import { __decorate, __extends } from "tslib";
import AvalonGTView from "@/utils/libs/BaseView";
import NavPanel from "@/components/common/NavPanel.vue";
import { Options } from "vue-class-component";
import IOS from "@/components/PrivacyProlicy/ios2.vue";
var View = /** @class */ (function (_super) {
    __extends(View, _super);
    function View() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    //@ 2021/12/29 15:42 跳转页面
    View.prototype.toPage = function (url) {
        this.globalCommit('setting_pageJump', Number(this.awlGlobalState.pageJump) + 1);
        this.$router.push({
            path: '/nav' + url,
            query: {
                navH: this.awlGlobalState.urlInitParams.navH,
                statusH: this.awlGlobalState.urlInitParams.statusH,
                version: this.awlGlobalState.urlInitParams.version,
                token: this.awlGlobalState.urlInitParams.token
            }
        });
    };
    View = __decorate([
        Options({
            components: { NavPanel: NavPanel, IOS: IOS }
        })
    ], View);
    return View;
}(AvalonGTView.BaseView));
export default View;
